<script lang="ts" setup>
import OrderItem, {type TOrder} from "@/components/profile/OrderItem.vue";
import Accordion from "primevue/accordion";
import {onMounted, ref} from "vue";

const props = defineProps<{ orders: TOrder[] }>()

const activeAccordion = ref(0)

onMounted(() => {
  if (!window.location.hash) {
    return
  }

  if (!window.location.hash.includes('#order-')) {
    return
  }

  const order = window.location.hash.split('-')[1]

  if (typeof order === 'undefined') {
    return
  }

  activeAccordion.value = props.orders.findIndex((_order: TOrder) => +_order.id === +order)

  const element = document.querySelector(`[data-id="order-${order}"]`)
  const header = document.querySelector('.header')

  if (!element || !header) {
    return;
  }

  const offset = header.getBoundingClientRect().height + 140 + window.scrollY
  setTimeout(() => {
    window.scrollTo({
      top: element.getBoundingClientRect().top - offset,
      behavior: 'smooth'
    });
  }, 0)
})

const updateHash = (index?: number): void => {
  if (typeof index === 'undefined') {
    return
  }

  window.location.hash = '#order-' + props.orders[index].id
}
</script>

<template>
  <Accordion v-if="props.orders.length" :value="activeAccordion" class="gap-2.5 desktop:gap-[30px] flex flex-col"
             @update:active-index="updateHash">
    <OrderItem v-for="(order, n) in props.orders" :key="order.id" :acc-value="n" :order="order"/>
  </Accordion>
  <div v-else class="p-5 pt-[30px]">
    <div class="grid place-items-center font-myriadPro">
      <div class="flex flex-col items-center gap-2.5">
        <h3 class="text-[38px] desktop:text-[2.5rem] leading-[90%] text-center">Вы не оформили ни одного заказа</h3>
        <p class="text-[18px] desktop:text-xl leading-none text-center">Подберите интересующие вас товары в разделе
          каталог</p>
        <a
          class="max-desktop:uppercase max-desktop:w-full inline-flex desktop:mt-2.5 items-center rounded-[3px] transition-colors disabled:pointer-events-none disabled:opacity-50 bg-[hsl(var(--roke-text-blue))] text-white justify-center text-lg font-semibold h-14 px-5 hover:bg-white hover:text-[hsl(var(--roke-text-blue))]"
          href="/catalog">
          <span class="mt-0.5">Перейти в каталог</span>
        </a>
      </div>
    </div>
  </div>
</template>
